import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPoints: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-point`, {
      ...parameters,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPointFilterList: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-point/list-filters`);
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPointWithoutPagination: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point`, { ...data });
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingPointGeneralDetails: (id: string): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/${id}`);
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingPointLocation: (id: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/charging-point-location/${id}`,
    );
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchRfidCards: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/rfid-cards`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingSchedules: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/charging-schedule`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingScheduleFilters: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/list-charging-schedule-filter`,
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchMaintenanceSchedules: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/maintenance-schedule`,
      {
        ...data,
      },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchMaintenanceScheduleFilters: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/list-maintenance-schedule-filter`,
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchMaintenanceScheduleReport: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/maintenance-schedule-report`,
      { ...data },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchUpcomingMaintenanceSchedule: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/upcoming-maintenance-schedule`,
      { ...data },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchGuestCharging: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/free-charging-schedule`,
      { ...data },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchListGuestChargingFilters: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/list-free-charging-filter`,
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingScheduleReport: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/charging-schedule-report`,
      { ...data },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchDeviceTransaction: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/transactions`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchListTransactionFilters: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/list-transaction-filter`,
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchTransactionReport: (data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/power-consumption-report`,
      { ...data },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchConnectorHistory: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/connector-history`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchDeviceAlerts: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/alerts`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchAlertReport: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/alerts-report`, {
      ...data,
    });
  },
  /**
   * Fetch the charging station list with pagination
   */
  updateFreeChargingSchedule: (id: string, data: any): Promise<any> => {
    return patchRequest(`${config.reportApiUrl}api/super-admin/v1/free-charging-schedule/${id}`, {
      ...data,
    });
  },
  /**
   * Delete the charging point
   */
  deleteChargingPoint: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/super-admin/v1/charging-point/${id}`);
  },
  /**
   * Get charging point details by Id
   */
  getChargingPointById: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-point/${id}`);
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchOcppLogs: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/ocpp-logs`, {
      ...data,
    });
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPointConceptionMonthWise: (id: string, queryParameters: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/charging-point-consumption-month-wise/${id}`,
      {
        ...queryParameters,
      },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchChargingPointConceptionByDate: (id: string, queryParameters: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/charging-point-consumption-by-date/${id}`,
      {
        ...queryParameters,
      },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchConnectorStatusByDate: (id: string, queryParameters: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/connector-status-by-date/${id}`,
      {
        ...queryParameters,
      },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchDeviceStatusByDate: (id: string, queryParameters: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-status-by-date/${id}`,
      {
        ...queryParameters,
      },
    );
  },
  /**
   * Fetch the charging point list with pagination
   */
  fetchDeviceStatusMonthWise: (id: string, queryParameters: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-status-month-wise/${id}`,
      {
        ...queryParameters,
      },
    );
  },
  /**
   * fetch the charging point status
   * @param id
   * @param data
   * @returns
   */
  editDeviceAvailableStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-point/status/${id}`,
      data,
      false,
    );
  },
  /**
   * edit the charging point status
   * @param id
   * @param data
   * @returns
   */
  editDeviceStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/free-charging/updateActiveStatus/${id}`,
      data,
      false,
    );
  },
  /**
   * get  Blocked Websocket Devices
   */
  fetchBlockedWebsocket: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/blocked-cps`, {
      ...parameters,
    });
  },

  /**
   * get  Never Blocked Websocket Devices
   */
  fetchNeverBlockedWebsocket: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/never-block-cps`,
      {
        ...parameters,
      },
    );
  },

  /**
   * get error logs websockets devices
   * @param query
   * @returns
   */
  fetchErrorLogs: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/error-logs`, {
      ...parameters,
    });
  },

  /**
   * add never block cp
   */
  addNeverBlockCP: (id: string): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/add-never-block-cp`,
      { sn: id },
    );
  },
  /**
   * Edit Un Blocked Websocket
   */
  editUnBlockedWebsocket: (id: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return patchRequest(
      `${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/unblock-cp/${id}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Delete the Never Block CP
   */
  deleteNeverBlockCp: (id: string): Promise<any> => {
    return deleteRequest(
      `${config.commonApiUrl}api/super-admin/v1/ocpp-ws-monitoring/remove-never-block-cp/${id}`,
    );
  },
};
